import { Wrapper, Row, Title, Description } from "./Banner.styled";

const Banner = ({ title, description }) => {
  return (
    <Wrapper>
      <Row>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
      </Row>
    </Wrapper>
  );
};

export default Banner;
